module.exports = __webpack_public_path__ + "img/dc-tesla.f83856e2.png";